// 📈 Courbes de la signature scientifique, une par matière (maquette Recherche.html) : dessinées
// dans un cadre de 1440 × 300, à droite du texte. axeY : hauteur de l'axe (hors cadre s'il n'y
// en a pas), d1 : trait principal, d2 : second trait, barreaux : traits fixes (ADN).
const W = 1440;

// Suite de points « M x y L x y … » de x0 à x1
const points = (f, x0 = 0, x1 = W, step = 8) => {
  let d = "";
  for (let x = x0; x <= x1; x += step) d += `${d ? " L" : "M"}${x} ${f(x).toFixed(1)}`;
  return d;
};

const maths = () => ({ axeY: 160, d1: points((x) => 160 - 90 * Math.sin((x - 560) / 120)), d2: "", barreaux: "" });

// Oscillation amortie et son enveloppe
const physique = () => ({
  axeY: 160,
  d1: points((x) => {
    const t = Math.max(0, x - 600) / 110;
    return 160 - 110 * Math.exp(-t / 3.2) * Math.cos(t * 2.1);
  }, 600),
  d2: points((x) => 160 - 110 * Math.exp(-Math.max(0, x - 600) / 110 / 3.2), 600, W, 16),
  barreaux: "",
});

// Double hélice et ses barreaux
const svt = () => {
  const f1 = (x) => 150 - 60 * Math.sin((x - 560) / 70);
  const f2 = (x) => 150 + 60 * Math.sin((x - 560) / 70);
  let barreaux = "";
  for (let x = 580; x <= W; x += 28) barreaux += ` M${x} ${f1(x).toFixed(1)} L${x} ${f2(x).toFixed(1)}`;
  return { axeY: -10, d1: points(f1, 560), d2: points(f2, 560), barreaux: barreaux.trim() };
};

// Signal binaire
const info = () => {
  const bits = [0, 1, 1, 0, 1, 0, 0, 1, 1, 1, 0, 1, 0, 1, 1, 0];
  let x = 560;
  let d = `M560 ${bits[0] ? 90 : 210}`;
  bits.forEach((b) => {
    const y = b ? 90 : 210;
    d += ` L${x} ${y} L${x + 56} ${y}`;
    x += 56;
  });
  return { axeY: 230, d1: d, d2: "", barreaux: "" };
};

// Offre et demande
const ses = () => ({
  axeY: 260,
  d1: points((x) => 250 - 190 * Math.pow((x - 600) / 840, 1.4), 600),
  d2: points((x) => 50 + 190 * Math.pow((x - 600) / 840, 1.4), 600),
  barreaux: "",
});

const FORMULAS = {
  maths: { fr: "y = sin x", en: "y = sin x" },
  physique: { fr: "x(t) = A·e^(−t/τ)·cos ωt", en: "x(t) = A·e^(−t/τ)·cos ωt" },
  svt: { fr: "ADN · double hélice", en: "DNA · double helix" },
  info: { fr: "0 1 1 0 1 0 0 1", en: "0 1 1 0 1 0 0 1" },
  ses: { fr: "offre = demande", en: "supply = demand" },
};

const BUILDERS = { maths, physique, svt, info, ses };
export const SUBJECT_CURVES = Object.keys(BUILDERS);

const cache = {};
// Courbe d'une matière (maths si la clé est inconnue), avec sa formule dans la langue du site
export const curveOf = (key, language = "fr") => {
  const k = BUILDERS[key] ? key : "maths";
  cache[k] = cache[k] || BUILDERS[k]();
  return { key: k, ...cache[k], formula: FORMULAS[k][language === "en" ? "en" : "fr"] };
};

// Nom d'une matière du site (français ou anglais) → courbe : « Physique-chimie » → physique…
const plain = (s) => String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
export const curveKeyOf = (subjectName) => {
  const n = plain(subjectName);
  if (/phys|chim/.test(n)) return "physique";
  if (/svt|bio|vie et de la terre|life/.test(n)) return "svt";
  if (/info|program|algo|computer/.test(n)) return "info";
  if (/\bses\b|eco|social|sociales/.test(n)) return "ses";
  return "maths";
};
